// extracted by mini-css-extract-plugin
export default {"tooltip":"PdfAutosavePromo__tooltip--2l0Kz","tooltipTitle":"PdfAutosavePromo__tooltipTitle--bqH5L","tooltipText":"PdfAutosavePromo__tooltipText--CEGte"};